import makeCrud from '@/store/site/localization/crud'
const module = makeCrud('manager_deployment')
module.actions.startDemo = async function (_, { data }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_deployment_demo'), data)
    return res.data
}
module.actions.startInstall = async function (_, { data }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_deployment_install'), data)
    return res.data
}
module.actions.advance = async function (_, { id }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_deployment') + '/' + id + '/advance')
    return res.data
}
export default module
